import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  type SelectChangeEvent,
  Skeleton,
} from "@mui/material";
import { useSetDefaultAffiliateLicenseMutation } from "Api/Mutations/Lead/useSetDefaultAffiliateLicenseMutation";
import { useGetAffiliateLink } from "Api/Queries/Lead/useGetAffiliateLink";
import { usePartyLicensesQuery } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Resources, useResource } from "Translations/Resources";
import { isLicenseActive } from "Utils/LicenseUtils";

const RESOURCES =
  Resources.Components.Affiliate.HunterAffiliate.MerchantLicenseSelector;

export const MerchantAffiliateLicenseSelector = () => {
  const { t } = useResource();
  const user = useLoggedInUser();
  const { data: licensesData, isLoading: isLoadingLicenses } =
    usePartyLicensesQuery(user?.partyPublicID);
  const { data: affiliateData, isLoading: isLoadingAffiliate } =
    useGetAffiliateLink("Merchant");
  const { mutate: setDefaultLicense } = useSetDefaultAffiliateLicenseMutation();

  const activeLicenses = licensesData?.items.filter(isLicenseActive) ?? [];

  const currentValue =
    affiliateData?.defaultAffiliateLicensePublicID ??
    activeLicenses[0]?.publicID ??
    "";

  const handleChange = (e: SelectChangeEvent<string>) => {
    setDefaultLicense({ licensePublicID: e.target.value });
  };

  if (isLoadingLicenses || isLoadingAffiliate) {
    return (
      <Box mt={4}>
        <Skeleton variant="rectangular" height={56} />
      </Box>
    );
  }

  if (activeLicenses.length === 0) {
    return null;
  }

  return (
    <Box mt={4}>
      <FormControl fullWidth>
        <InputLabel>{t(RESOURCES.Label)}</InputLabel>
        <Select
          value={currentValue}
          label={t(RESOURCES.Label)}
          onChange={handleChange}
        >
          {activeLicenses.map(({ publicID, licenseNo, code }) => (
            <MenuItem key={publicID} value={publicID}>
              {licenseNo ? `${code} - ${licenseNo}` : code}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
